import { runFunction } from "../../http";
import { convertObject } from "../../../lib/utils";
import { SettingFeatureData } from "../../../types";

export const getFeatureSettings = async (): Promise<SettingFeatureData> => {
  console.debug("[Service] getFeatureSettings");
  const parseResponse = await runFunction("getFeatureSettings");
  return convertObject(parseResponse);
};
